import { useCookies } from 'react-cookie';
import { COMPLIANCE_KEY } from './constants';

export const useComplianceCookie = () => 
{
    const [{ qlCompliance }, setCookie] = useCookies([`${COMPLIANCE_KEY}`]);

    const setComplianceCookie = (options) => 
    {
        setCookie(`${COMPLIANCE_KEY}`, { isClosed: true, ...options }, {
            path: '/', // make accessible for all pages
            expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000), // 365 days
        });
    };

    return {
        qlCompliance,
        setComplianceCookie,
    };
};
